"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Hide = _interopRequireDefault(require("../Hide"));
const Desktop = ({
  children
}) => /*#__PURE__*/_react.default.createElement(_Hide.default, {
  on: ["desktop", "largeDesktop"]
}, children);
var _default = Desktop;
exports.default = _default;